import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownButton, DropdownButtonContext, Tooltip, } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { findLabelByLanguageCode, } from 'app/utils/supportedLanguages';
import { requestAvailableSatisfactionLanguages } from 'components/conversation/api/satisfaction';
import { SatisfactionDropdown } from './components/SatisfactionDropdown';
export const SatisfactionButton = ({ channel, contactPoint, selected, isCancellable, onToggle, onChange, onCancel, }) => {
    const [languageCodes, setLanguageCodes] = useState([]);
    const [languageCodesAsyncStatus, setLanguageCodesAsyncStatus] = useState('succeeded');
    useEffect(() => {
        setLanguageCodesAsyncStatus('loading');
        requestAvailableSatisfactionLanguages({
            channel,
            contactPoint,
        })
            .then((response) => {
            setLanguageCodes(response.data.languages);
            setLanguageCodesAsyncStatus('succeeded');
        })
            .catch(() => setLanguageCodesAsyncStatus('failed'));
    }, [channel, contactPoint]);
    // Default to English if the selected language is not supported
    const selectedLanguage = languageCodes.includes(selected) ? selected : 'en';
    return languageCodes.length > 0 ? (_jsx(Tooltip, Object.assign({ content: `CSAT ${findLabelByLanguageCode(selectedLanguage)}`, dark: true }, { children: _jsx(DropdownButton, { icon: "smile", "data-testid": "csat-button", onToggle: (isOpen) => onToggle && onToggle(isOpen), dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(SatisfactionDropdown, { selected: selectedLanguage, languageCodes: languageCodes, languageCodesAsyncStatus: languageCodesAsyncStatus, cancelAsyncStatus: 'succeeded', isCancellable: isCancellable, toggleDropdown: toggleDropdown, onChange: onChange, onCancel: onCancel })) }) }) }))) : null;
};
